<template>
  <div>
    <div v-if="!propLote"
         class="p-0 m-0">
      <button
        id="btn-proclamas"
        :disabled="propDataPublicacao"
        class="btn btn-primary btn-sm"
        @click="handlePublicacao">
        Publicar no e-Proclamas
      </button>
      <p v-if="propDataPublicacao"
         class="data-eproclamas">
        Publicado {{ propDataPublicacao | date }}
      </p>
    </div>
  </div>
</template>
<script>
  /* helpers */
  import ProclamasSignature from '@/signature/ProclamasSignature'

  /* helpers */
  import ErrorsCasamentoHelper from "@/helpers/Errors/ErrorsCasamentoHelper"

  /* constants */
  import erros from '@/constants/errosCarga'
  import errorsList from '@/constants/errorsCasamento'

  /* services */
  import CargaProclamasService from "@/services/CargaProclamasService"
  import AuthService from "@/services/Auth/AuthService"
  
  /* others */
  import { mapGetters } from 'vuex'

  export default {
    name: 'EProclamas',
    props: {
      propRegistro: { type: Object, default: null },
      propDataPublicacao: { type: String, default: null},
      propLote: { type: Boolean, default: false },
      propRegistros: { type: Array, default: () => ([])},
      propResultados: { type: Array, default: () => ([])}
    },
    data () {
      return {
        assinadorPublicacao: null,
        publicacao: false,
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser',
        cartorioId: "auth/getCartorioId",
        userCartorios: "auth/getUserCartorios",
      }),
    },
    methods: {
      async handlePublicacao () {
        //Se já tiver data de publicação impedimos a publicação
        if (this.propDataPublicacao) return

        /**
         * Vericamos se o tipo de publicação não é em lote
         */
        if (this.propLote) {
          if (!this.propRegistros.length) return this.displayError('', 'Nenhum registro selecionado.')
        }

        // Nova API do e-Proclamas — desenvolvida por Moacir Durazzo Junior
        try {
          let textoSucesso
          let registros = this.propRegistro
          let end 

          // Pegar o Cns do cartório
          const { cns } = this.userCartorios.reduce((accumulator, currentValue) => {
            if (currentValue.cartorio_id === this.cartorioId) {
              accumulator.cns = currentValue.cns + ''
              return accumulator
            }
            return accumulator
          } , {})
            
          // Dados que compõem o payload da requisição
          if (typeof registros !== 'object' || registros === null) {
            registros = { registrosIds: this.propRegistros }
          }
          
          // Obtém o accessToken do IdRC para validar/renovar.
          const { access_token: accessToken } = (await AuthService.checkIsLoggedIn()).data
          const data = { ...registros, token: accessToken, cns }

          // Publicação de registros iniciada a partir do "GERENCIADOR DE TAREFAS"
          if (this.propLote && this.propRegistros.length) {
            const isSingleRegistro  = this.propRegistros.length === 1
            end = await CargaProclamasService.validarIntegracaoEProclamas(data)
            textoSucesso = `${isSingleRegistro ? 'Publicação enviada' : 'Publicações enviadas'} com sucesso!`
          } else {
            // Publicação de registros iniciada a partir do "RESUMO"
            end = await CargaProclamasService.validarIntegracaoEProclamas(data)
            textoSucesso = 'Publicação enviada com sucesso!'
          }
          // Após a conclusão bem-sucedida do processo, uma mensagem de sucesso será exibida.
          if (!end.erros.length && end.sucesso.length) {
            this.displaySuccess('', textoSucesso).then(() => {
              this.$emit('reload', true)
            })
          } else {
            throw new Error(JSON.stringify(end))
          }
          return
        } catch (error) {
          let erroInfo

          if (error.message.includes('Request failed')) erroInfo = error.response.data
          else erroInfo = JSON.parse(error.message)

          const { erros, sucesso } = erroInfo
          const maxLength = Math.max(erros.length, sucesso.length)
          let sucessoJaMostrado = false
          let errosJaMostrado = false
          let mensagemFinal = ''
            
          for (let i = 0; i < maxLength; i++) {
            const mensagemInfo = erros[i].mensagem

            if (erros.length === 1 && !sucesso.length) {
              if (mensagemInfo.hasOwnProperty('status') && mensagemInfo.status === 'error') {
                this.displayError('Erro ao enviar a publicação!', mensagemInfo.hasOwnProperty('details') ? this.mapApiError (mensagemInfo.details) : mensagemInfo.message)
              } else this.displayError('Erro ao enviar a publicação!', 'Houve algum erro ao realizar a publicação, favor contactar o suporte.')
              
            } else {
              // Adiciona os registros publicados com sucesso
              if (sucesso.length && !sucessoJaMostrado) {
                sucesso.forEach(item => {
                  mensagemFinal += `✅ Habilitação publicada com sucesso! \n Matrícula: ${item.matricula}\n\n`
                })
                sucessoJaMostrado = true
              }

              // Adiciona os registros que deram errado
              if (erros.length && !errosJaMostrado) {
                erros.forEach(erro => {
                  mensagemFinal += `❌ Erro na matrícula: ${erro.registro.matricula} \n Mensagem: ${ erro.mensagem.hasOwnProperty('details') ? this.mapApiError (erro.mensagem.details) : erro.mensagem.message}\n\n`
                })
                errosJaMostrado = true
              }

              // Exibe a mensagem final
              if (mensagemFinal) {
                const mensagemFormatada = mensagemFinal.replace(/\n/g, '<br>')
                this.displayError('Erro ao enviar a publicação!', '', mensagemFormatada)
                this.$emit('reload', true)
              }
            }
          }
        }
      },
      async publicacaoUnica (certificado) {
        try {
          loader({ text: "Enviando publicação...", active: true })
          // Passamos o certificado selecionado para a classe de assinatura
          this.assinadorPublicacao.onSelectCertificado(certificado)

          // Iniciamos a assinatura passando o id do registro
          const res = await this.assinadorPublicacao.publicacao(this.propRegistro.registro_id)

          // Se não tiver erros retornamos uma mensagem de sucesso e recarregamos o registro
          if (!res.errors || !res.errors.length) {
            this.displaySuccess('', 'Publicação enviada com sucesso').then(() => {
              this.$emit('reload', true)

              this.publicacao = true
            })
          } else {
            // Procuramos um erro que tenha mensagem (array ou string)
            const errors = res.errors.find(error => error.message)

            if (errors) {
              // Verificamos se a mensagem é um array ou uma string
              if (Array.isArray(errors.message)) {
                // exibimos o erro em forma de lista
                return this.displayListErrors('Erro ao enviar a publicação!', errors.message)
              } else {
                // tratamos o erro para tranforma-lo em um array e exibi-lo em forma de lista
                this.tratarErros(errors.message)
              }
            } else {
              // Caso não tenha mensagem de erro retornamos uma mensagem genérica
              return this.displayListErrors('Erro ao enviar a publicação!', 'Houve algum erro ao realizar a publicação, favor contactar o suporte.')
            }
          }
        } catch (error) {
          // Usamos esse metodo para verificar o tipo de erro e retornar de forma adequada
          this.filterErros(error)
        } finally {
          loader({ text: "", active: false })
        }
      },
      async publicacaoLote (certificado) {
        // caso nenhum registro esteja selecionado, impedimos a assinatura de iniciar
        if (!this.propRegistros.length) this.displayError('', 'Nenhum registro selecionado.')

        try {
          loader({ text: "Enviando publicação...", active: true })
          // Passamos o certificado selecionado para a classe de assinatura
          this.assinadorPublicacao.onSelectCertificado(certificado)
          // Enviamos todos os registros iniciados para a publicacao em lote
          const res = await this.assinadorPublicacao.publicacao(this.propRegistros)

          // Se não tiver erros retornamos uma mensagem de sucesso e recarregamos as tarefas
          if (!res.errors || !res.errors.length) {
            // Retornamos a mensagem de sucesso gerada pelo back
            await this.displaySuccess(res.end.message)
          } else {
            // Tratamos o erro para exibi-los em uma lista com suas respectivas tarefas
            const erro = {
              status: true,
              text: res.end.message,
              tasks: Array.isArray(res.errors) ? res.errors : [res.errors]
            }

            this.$emit('showErrors', erro)
          }

          //Atualizamos as tarefas
          this.$emit('reload', true)
        } catch (error) {
          // Usamos essa função para verificar o tipo de erro e retornar de forma adequada
          this.filterErros(error)
        } finally {
          loader({ text: "", active: false })
        }
      },
      filterErros (error) {
        const { response } = error

        if (response) {
          const { data } = response

          if (data) {
            const {message, errors} = data

            if (message) {
              if (message.message) {
                // Verificamos se o erro é de validação de xds se não for tratamos
                if (message.message.match('com o XSD')) {
                  return this.displayError('Erro ao enviar a publicação', 'Erro de validação com o XSD.')
                } else {
                  return this.tratarErros(message.message)
                }
              } else if (Array.isArray(message)) {
                // Verificamos se a mensagem já vem como array e apenas a exibimos em lista
                return this.displayListErrors('Erro ao enviar a publicação!', message)
              } else if (message.match(/.*504 Gateway Time-out.*/)) {
                // Verificamos se o erro é de time-out
                return this.displayError('Erro ao enviar a publicação!', '504 Gateway Time-out')
              } else {
                // Caso não entre em nenhum exibimos a mensagem diretamente
                return this.displayError('Erro ao enviar a publicação!', message)
              }
            } else if (errors) {
              // Verificamos se o erro tem items
              if (Array.isArray(errors) && errors.length) {
                // verificamos se a publicação foi em lote para exibir corremente a lista de erros
                if (this.propLote) {
                  if (errors) {
                    /**
                     * Se der erro na primeira parte da assinatura não virá
                     * mensagem do back então editamos uma com a quantidade de
                     * erros retornados e enviamos para a exibição
                     */
                    const erro = {
                      status: true,
                      text: data.message ? data.message : `0 cargas realizadas com sucesso e ${errors.length} cargas com erro.`,
                      tasks: Array.isArray(errors) ? errors : [errors]
                    }

                    return this.$emit('showErrors', erro)
                  }
                } else {
                  /**
                   * Se não for publicação em lote exibimos apenas o primeiro item
                   * e verificamos se esse item é um array para poder trata-lo
                   */
                  if (errors[0].message && Array.isArray(errors[0].message)) return this.displayListErrors('Erro ao enviar a publicação!', errors[0].message)
                  else if (errors[0].message) return this.displayError('Erro ao enviar a publicação!', errors[0].message)
                  return this.displayError('Erro ao enviar a publicação!', 'Houve algum erro ao realizar a publicação, favor contactar o suporte.')
                }
              } else {
                /**
                 * Caso não tem nenhum erro exibimos uma mensagem generica pois
                 * não teremos como saber qual erro aconteceu
                 */
                return this.displayError('Erro ao enviar a publicação!', 'Houve algum erro ao realizar a publicação, favor contactar o suporte.')
              }
            } else {
              // Se não tiver errors e nem message exibimos diretamente o data
              return this.displayError('Erro ao enviar a publicação', JSON.stringify(data))
            }
          } else {
            // Se não tiver data exibimos diretamente a response
            return this.displayError('Erro ao enviar a publicação', JSON.stringify(response))
          }
        } else {
          // Verificamos se o erro tem descrição e se não tiver exibimos o erro diretamente
          if (error.description) return this.displayError('Erro ao enviar a publicação!', error.description)
          return this.displayError('Erro ao enviar a publicação!', JSON.stringify(error))
        }
      },
      displaySuccess (title, text, html) {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = html

        return Swal.fire(objSwal.success).then((res) => {
          objSwal.success.title = ''
          objSwal.success.text = ''
          objSwal.success.html = ''

          return res
        })
      },
      displayError (title, text, html) {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = html

        return Swal.fire(objSwal.error).then((res) => {
          objSwal.error.title = ''
          objSwal.error.text = ''
          objSwal.error.html = ''

          return res
        })
      },
      displayListErrors (title, listErrors) {
        /**
         * Pegamos as keys de acordo com o tipo de registro
         *
         * Essas keys são indicativos de campos que aparecem no formulario
         * EX: GENITOR, NATURALIDADE, ETC.
         */

        const keys = Object.keys(erros.casamento)
        const errosRegistro = erros.casamento

        const correcoes = {}

        /**
         * Percorremos essas keys juntamente com a lista de erros
         * para verificar se existe alguma palavra em algum erro da lista
         * que é igual a alguma das keys
         *
         * Se for igual retornaremos o objeto de correções com as keys encontras
         * e o valor será a aba correspondente ao erro
         */
        keys.forEach((key) => {
          listErrors.forEach(err => {
            err = err.toUpperCase()

            if (err.match("\\b" + key + "\\b")) {
              correcoes[key] = errosRegistro[key]
            }
          })
        })

        // Transformamos os erros em lista para exibi-los
        const text = `<ul>${listErrors.map(res => {
          // Trocamos palavras erradas
          errorsList.forEach(err => {
            res = res.replace(err.name, err.value)
          })

          return `<li>${ res }</li>`
        })}</ul>`

        objSwal.question.title = title
        objSwal.question.html = text.replace(/\,|Conteúdo da tag |caso tag esteja vazia/g,'')
        objSwal.question.confirmButtonText = 'Continuar'

        return Swal.fire(objSwal.question).then((resp) => {
          delete objSwal.question.html

          /**
           * Se o usuario desejar corrigir os erros irá diretamente para a tela
           * de edição do registro juntamente com as suas correções a serem feitas
           */
          if (resp.value) {
            if (this.propRegistro.registro.tipo_registro === 'D') {
              this.$router.push({name: 'editar_habilitacao_casamento', params: {
                id: this.propRegistro.habilitacao_casamento_id
              }})
            } else {
              this.$router.push({name: 'editar_casamento', params: { id: this.propRegistro.casamento_id, propCorrecoes: correcoes, propCasamento: this.propRegistro }})
            }
          }
        })
      },
      tratarErros (error) {
        // Verificamos se o erro é de validação de xds
        const message = error.message ? error.message.match('com o XSD') : error.match('com o XSD')

        if (message) {
          return this.displayError('Erro ao enviar a publicação', 'Erro de validação com o XSD.')
        }

        // Tratamos o erro de acordo com o tipo de registro

        const erros = ErrorsCasamentoHelper.errosCasamento(erros.message ? erros.message : error)

        /**
         * Pegamos o primeiro item da lista como titulo e o removemos para
         * não aparecer novamente na lista
         */
        const title = erros[0]
        erros.shift()

        // Enviamos o titulo e o erros para a função que exibe em forma de lista
        return this.displayListErrors(title, erros)
      },
      mapApiError (errorString) {
        const isErrorString = typeof errorString === 'string'

        if (isErrorString && errorString.includes('504 Gateway Time-out')) {
          return 'Estamos com instabilidade. Tente novamente em alguns instantes.'
        } else if (isErrorString && errorString === 'this batch was already processed') {
          return 'Esta habilitação já foi processada!'
        }
        return errorString
      }
    },
  }
</script>
<style lang="scss">

</style>
